import type { ShapeSalesTaxConfiguration } from "@aprao/model/src/shapes/ShapeProject.js";

export const buildSalesTaxName = (
  salesTaxConfiguration: ShapeSalesTaxConfiguration,
) =>
  `${
    salesTaxConfiguration.name.trim() === "" ?
      "Tax"
    : salesTaxConfiguration.name
  } on sales`;
